module.exports = __webpack_public_path__ + "static/media/ulip.89b3a03c.mp3";